// used in profile store
export const useProfileFamilyWatcher = () => {
  // will open dialog if added to a new family
  useFamilyNewMemberNomad();
  // will open dialog if member has sared is data
  useFamilyShareDataDiff();
};
